import { Flex, Text } from 'src/components';
import { StarIcon } from 'src/components/icons/star.icon';

interface StarRatingProps {
  rating: number;
}

const TOTAL_STARS = 5;
const GREY = '#D1D5DB';

export const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const clamped = Math.max(0, Math.min(rating, TOTAL_STARS));
  const full = Math.floor(clamped);
  const fraction = clamped - full;

  return (
    <Flex align="center" gap={8}>
      <Flex gap={2}>
        {Array.from({ length: TOTAL_STARS }, (_, i) => {
          if (i < full) return <StarIcon color="#F4901F" key={i} />;
          if (i === full && fraction > 0) {
            return (
              <>
                <span key={i} style={{ position: 'relative', display: 'inline-flex', width: 12, height: 12 }}>
                  <StarIcon color={GREY} style={{ position: 'absolute', left: 0, top: 0 }} />
                  <span style={{ position: 'absolute', left: 0, top: -3, width: `${fraction ? 50 : 100}%`, overflow: 'hidden' }}>
                    <StarIcon color="#F4901F"/>
                  </span>
                </span>
              </>
            );
          }
          return <StarIcon key={i} color={GREY} />;
        })}
      </Flex>
      <Text type="small" bold>
        {clamped} / {TOTAL_STARS}
      </Text>
    </Flex>
  );
};
